import { sendEventToGTM } from '../src/utils/tag_manager'

// Define search type constants for different page categories
const PAGEVIEW = 'pageView'
const PROJECTS = 'projects'
const PRODUCTS = 'products'
const IMAGES = 'images'
const PROFESSIONALS = 'professionals'

// Define arrays of filters
const EMPTY_ARRAY = []
const TYPES_WITH_FILTER = [PROJECTS, PRODUCTS, IMAGES, PROFESSIONALS]
const FILTERS_KEYS_ARR = [
  'year',
  'offices',
  'categories',
  'materials',
  'country',
  'countries',
  'color',
  'max_area',
  'min_area',
  'properties',
  'use',
  'companies',
  'bim',
  'product_type',
  'fixtures_and_furniture',
  'image_type',
  'building_element',
  'space',
  'environment',
  'expertise',
  'states'
]

// Convert URL path into an object containing active filters
const urlPathToObject = (location, type, arr = FILTERS_KEYS_ARR) => {
  const urlPathArray = findUrlPathArray(location) || EMPTY_ARRAY
  const indexToFindFilters = urlPathArray.findIndex(p => TYPES_WITH_FILTER.includes(p)) + 1
  const filtersParams = urlPathArray.slice(indexToFindFilters)
  return filtersParams.reduce((acc, curr, idx) => {
    if (arr.includes(curr) && idx % 2 === 0) {
      acc[curr] = decodeURIComponent(filtersParams[idx + 1]).replace('slash', '/')
    }
    return acc
  }, {})
}

const findUrlPathArray = location => {
  return location &&
    location.pathname &&
    encodeURI(location.pathname).replace('%20/%20', '%20slash%20').split('/')
}

const pageViewToGTM = () => {
  // Temporarly to test the implementation just on projects
  const searchType = location.pathname.search('/projects') > -1 ? PROJECTS : null

  if (searchType) {
    const activeFilters = urlPathToObject(location, PROJECTS)

    sendEventToGTM(searchType, PAGEVIEW, activeFilters)
  }
}

pageViewToGTM()
